import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';


function SideMenu({ isSidebarOpen, toggleSidebar }) {

    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuhome) => {
        setOpenMenu(openMenu === menuhome ? null : menuhome);
    };


    // useEffect(() => {
    //     const sidebar = document.getElementById('side-bar');
    //     const anywhereHome = document.getElementById('anywhere-home');

    //     if (isSidebarOpen) {
    //         sidebar.classList.add('show');
    //         anywhereHome.classList.add('bgshow');
    //     } else {
    //         sidebar.classList.remove('show');
    //         anywhereHome.classList.remove('bgshow');
    //     }
    // }, [isSidebarOpen]);


    return (
        <div>
            <div id="side-bar" className={`side-bar ${isSidebarOpen ? 'show' : ''}`}>
                <button className="close-icon-menu" aria-label="Close Menu" onClick={toggleSidebar}>
                    <i className="far fa-times"></i>
                </button>
                {/* inner menu area desktop start */}
                <div className="rts-sidebar-menu-desktop">
                    <Link to="/">
                        <img
                            className="logo"
                            src="/av_buss_logo.png"
                            alt="Aviteus Business Solutions"
                            style={{maxWidth: '200px', height: 'auto'}}
                        />
                    </Link>
                    <div className="body d-none d-xl-block">
                        <p className="disc">
                            Expert accounting, tax planning, and business advisory services to help your business thrive.
                        </p>
                        <div className="get-in-touch">
                            {/* title */}
                            <div className="h6 title">Get In Touch</div>
                            {/* title End */}
                            <div className="wrapper">
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <Link to="tel:02046288209">020 4628 8209</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-envelope" />
                                    <Link to="mailto:info@aviteusbusiness.co.uk">info@aviteusbusiness.co.uk</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-map-marker-alt" />
                                    <Link to="#">Alpha House, 296 Kenton Rd, Harrow HA3 8DD, UK</Link>
                                </div>
                                {/* single ENd */}
                            </div>
                            <div className="social-wrapper-two menu">
                                <Link to="#">
                                    <i className="fab fa-facebook-f" />
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-twitter" />
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-linkedin-in" />
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-instagram" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="body-mobile d-block d-xl-none">
                        <nav className="nav-main mainmenu-nav">
                            <ul className="mainmenu metismenu" id="mobile-menu-active">
                                <li className="menu-item">
                                    <Link className="menu-link" to="/" onClick={toggleSidebar}>
                                        Home
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to="/about-us" onClick={toggleSidebar}>
                                        About Us
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to="/services" onClick={toggleSidebar}>
                                        Services
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to="/contactus" onClick={toggleSidebar}>
                                        Contact Us
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <div className="social-wrapper-two menu mobile-menu">
                            <Link to="#">
                                <i className="fab fa-facebook-f" />
                            </Link>
                            <Link to="#">
                                <i className="fab fa-twitter" />
                            </Link>
                            <Link to="#">
                                <i className="fab fa-linkedin-in" />
                            </Link>
                            <Link to="#">
                                <i className="fab fa-instagram" />
                            </Link>
                        </div>
                        <Link
                            to="/contactus"
                            className="rts-btn btn-primary ml--20 ml_sm--5 header-one-btn quote-btnmenu"
                            onClick={toggleSidebar}
                        >
                            Book a Consultation
                        </Link>
                    </div>
                </div>
                {/* inner menu area desktop End */}
            </div>


        </div>
    )
}

export default SideMenu